import React from 'react';
import { getPortNameWithShy } from '../utils';
import Icons, { IconNames } from './icons';
import { Default, Mobile } from '../responsive';

export default class ListItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClickItem = this.onClickItem.bind(this);
  }

  itemShouldBeHighlighted(index) {
    if (this.props.itemHighlights === null || this.props.itemHighlights === undefined) {
      return false;
    }

    return this.props.itemHighlights;
  }

  onClickItem() {
    if (this.props.onClickItem) {
      this.props.onClickItem(this.props.items, this.props.headers);
    }
  }

  renderCell(item, index) {
    const cssClasses = [];
    const itemWithShy = getPortNameWithShy(item);
    let content = null;

    if (this.itemShouldBeHighlighted(index)) {
      cssClasses.push('list__items__highlight');
    }

    if (itemWithShy) {
      content = <div className="inner" dangerouslySetInnerHTML={{ __html: itemWithShy }} />;
    } else {
      content = <div className="inner">{item}</div>;
    }

    console.log(item);

    return (
      <span key={index} className={cssClasses.join(' ')}>
        {content}
      </span>
    );
  }

  renderItem() {
    const items = this.props.items;
    const headers = this.props.headers || this.props.items;

    if (this.props.renderOnlyFirstItem && this.props.onClickItem) {
      return (
        <React.Fragment>
          {this.renderCell(items[0], 0)}
          <span className="list__item__iconwrapper">
            <Icons
              iconName={IconNames.ArrowRight}
              iconClassName="portLink"
              className="portLinkWrapper"
            />
          </span>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {Object.keys(headers).map((key, index) => {
          let item = items[key];
          return this.renderCell(item, index);
        })}
      </React.Fragment>
    );
  }

  renderIcon() {
    if (this.props.items.current) {
      return (
        <Icons
          iconName={IconNames.SortRight}
          iconClassName="arrowRight"
          className="arrowRightWrapper"
        />
      );
    }
  }

  render() {
    const Tag = this.props.tag;

    return (
      <Tag className={this.props.className} onClick={this.onClickItem}>
        {this.renderIcon()}
        {this.renderItem()}
      </Tag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listitem.js